// extracted by mini-css-extract-plugin
export default {"wrap":"_H-z","articleImagesWrap":"aI-z","articleImage":"bI-z","singleImage":"cI-z"};